import React, { memo } from "react";
import Grid from "@material-ui/core/Grid";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";

const EvalRadio = memo(({ data, que, ldata, index, handleChange }) => {
  return (
    <Grid key={index}>
      <FormControlLabel
        value={que[data.no - 1]}
        control={
          <Radio
            checked={que[data.no - 1] === index}
            value={que[data.no - 1]}
            onChange={(e) => handleChange(data.no - 1, index)}
            name="radio-buttons"
            color="primary"
            inputProps={{ "aria-label": { ldata } }}
          />
        }
        label={ldata}
      />
    </Grid>
  );
});

export default EvalRadio;
